import { ApplicationQuestionsData } from '@hooks/jobsBoard/useApplyToApplicationJob';
import { StyledGapContainer } from '@views/auth/signup/styles';

import {
  StyledFormItem,
  StyledImageContainer,
  StyledLabel,
  StyledSelect,
  StyledTextArea,
} from '../styles';

type JobQuestionProps = {
  question: ApplicationQuestionsData['questions'][number];
};
export const JobQuestion = ({ question }: JobQuestionProps) => {
  return (
    <StyledGapContainer gap={4}>
      <StyledLabel label={question.label} requiredSymbol={question.required} />
      {!!question?.descriptionImage && (
        <StyledImageContainer>
          <img src={question.descriptionImage} alt={question.label} />
        </StyledImageContainer>
      )}
      <StyledFormItem
        name={question.listColumnId}
        rules={[
          {
            required: question.required,
            message: 'This field is required',
          },
        ]}
      >
        {question?.responseType === 'Free text' ? (
          <StyledTextArea placeholder='Type here' />
        ) : (
          <StyledSelect
            options={
              question?.options?.map((option) => ({
                label: option,
                value: option,
              })) || []
            }
            placeholder={
              question?.responseType === 'Single-choice'
                ? 'Select one'
                : 'Select all that apply'
            }
            mode={
              question?.responseType === 'Multiple-choice'
                ? 'multiple'
                : undefined
            }
            allowClear
            showArrow
          />
        )}
      </StyledFormItem>
    </StyledGapContainer>
  );
};
